import { render, staticRenderFns } from "./CumpleanosCalendario.vue?vue&type=template&id=7e7644cc"
import script from "./CumpleanosCalendario.vue?vue&type=script&lang=js"
export * from "./CumpleanosCalendario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports